import { NgModule } from '@angular/core'

import { PhonePipe } from './phone.pipe'
import { FeetAndInchesPipe } from './feet-and-inches.pipe'
import { WordsPipe } from './words.pipe'
import { TruthyPipe } from './truthy.pipe'
import { ReadableListPipe } from './readable-list.pipe'

@NgModule({
  declarations: [FeetAndInchesPipe, PhonePipe, ReadableListPipe, TruthyPipe, WordsPipe],
  imports: [],
  exports: [FeetAndInchesPipe, PhonePipe, ReadableListPipe, TruthyPipe, WordsPipe],
  providers: [FeetAndInchesPipe, PhonePipe, ReadableListPipe, TruthyPipe, WordsPipe],
})
export class PipesModule {}
